// Core modules
require('./bootstrap');
require('./bootstrap-mdbvue');
require('./appConfig');

//require('./juniorApi'); // @note Injected in ./vue.config.js
//require('./mathApi');   // @note Injected in ./vue.config.js
//require('./api');       // @note Injected in ./vue.config.js
